<script setup>
import {computed, onMounted} from 'vue'
import {useStore} from 'vuex'
import { MapSource, MapLayer } from '@/components/map'
import { Spinner } from '@/components/ui/spinner'
import {CheckCircle2, XCircle} from 'lucide-vue-next'

const protocol = location.protocol === 'https:' ? 'https' : 'http'
const host = `${protocol}://${window.location.host}`

const store = useStore()
const map = computed(() => store.getters['geo/getMap'])
const layersToken = computed(() => store.getters['geo/getTilesToken'])

const emit = defineEmits(['isLoaded'])
const props = defineProps({
  map: {
    type: Object,
    required: true
  },
  layerId: {
    type: String,
    required: true
  },
  beforeId: {
    type: String,
    required: true
  },
  groupId: {
    type: String,
    required: true
  },
  options: {
    type: Object,
    required: false,
    default: () => ({})
  },
  layer: {
    type: Object,
    required: false,
    default: () => ({})
  }
})

const statusToLabel = {
  '4': 'Creating tiles',
  '3': 'Waiting for result',
  '2': 'Activating',
  '1': 'Initializing',
  '0': 'Done',
  '-1': 'Failed: Initialization',
  '-2': 'Failed: Activation',
  '-3': 'Failed: Waiting for result',
  '-4': 'Failed: Creating tiles',
}

onMounted(async () => {
  emit('isLoaded', true)
})
</script>

<template>
  <div class="flex items-center my-1" v-if="parseInt(layer.status) !== 0">
    <div class="mr-2">
      <XCircle v-if="parseInt(layer.status) < 0" class="text-red-400 w-5 h-5" />
      <Spinner v-else class="w-5 h-5" />
    </div>
    <h4>{{ statusToLabel[layer.status] }}</h4>
  </div>
  <div v-if="map && layersToken">
    <MapSource
      v-if="parseInt(layer.status) === 0"
      :map="map"
      type="raster"
      :id="`${layerId}-test-tiff-tiles-source`"
      :options="{
        tiles: [`${host}/tulum/tiles/orders/${layer.planet_order_id}/{z}/{x}/{y}.png?token=${layersToken}`],
        tileSize: 256,
      }"
    >
      <MapLayer
        :map="map"
        :id="`${layerId}-test-tiff-tiles-layer`"
        type="raster"
        :source="`${layerId}-test-tiff-tiles-source`"
        :before-id="beforeId"
        :group-id="groupId"
        :options="options"
      ></MapLayer>
    </MapSource>
  </div>
</template>
